/**
 * @generated SignedSource<<a0f74fd1d28ab0785a7e13242faa6755>>
 * @relayHash 0dd246a45e06b932ab1b8570b0e2a26f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63

import type { ConcreteRequest } from 'relay-runtime';
export type AudienceSegmentationContextProviderQuery$variables = {
  accountId?: string | null | undefined;
};
export type AudienceSegmentationContextProviderQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly groupsWithId: ReadonlyArray<{
        readonly id: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type AudienceSegmentationContextProviderQuery = {
  response: AudienceSegmentationContextProviderQuery$data;
  variables: AudienceSegmentationContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "Group",
            "kind": "LinkedField",
            "name": "groupsWithId",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AudienceSegmentationContextProviderQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AudienceSegmentationContextProviderQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0dd246a45e06b932ab1b8570b0e2a26f",
    "id": "9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63",
    "metadata": {},
    "name": "AudienceSegmentationContextProviderQuery",
    "operationKind": "query",
    "text": "query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id,confluence{groupsWithId{id}}}}"
  }
};
})();

(node as any).hash = "d01bf7959fed02b6636fa27826de406a";

export default node;
